import type { Group23Info } from 'src/models';

export type DeviceCore = {
  id: number;
  deviceId: string;
  carName: string;
  carKind: string;
  groupId: number;
  machineType: string | null;
  firmwareVersion: string | null;
  settings: string | null;
  deviceAttachedOn: string | null;
  stoppedUseOn: string | null;
  avatarUrl: string | null;
  bikou1: string | null;
  deletedAt: string;
};

export type Device = DeviceCore & {
  groupInfo: Group23Info;
};

export type AdminDevice = Device;

export interface DeviceInputModel {
  id: number | null; // null = 新規作成
  deviceId: string;
  carName: string;
  carKind: string | null;
  group2Id: number | null;
  groupId: number | null;
  stoppedUseOn: Date | null;
  bikou1: string | null;
}

export const createDeviceInitInputModel = (): DeviceInputModel => ({
  id: null,
  deviceId: '',
  carName: '',
  carKind: null,
  group2Id: null,
  groupId: null,
  stoppedUseOn: null,
  bikou1: '',
});
